import "core-js/modules/es.array.push.js";
import { useMainStore } from "../pinia/main";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive, ref } from "vue";
import { EncryptName, exportFile, isPassAuth, isPhoneNumber, phoneDesc } from "../util/index";
import moment from "moment";
import { freightUnitTypeMap } from "@/util/type";
import { ElMessage } from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import logo from "../assets/imgs/logo/ic_launcher.png";
import QRCode from "qrcode";
import html2canvas from "html2canvas";

import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message-box/style/css';
export default {
  name: "Shipments",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const qrCanvas = ref(null);
    const picContainer = ref(null); // 对应上面的 ref
    const data = reactive({
      inputData: [],
      tabsIndex: 0,
      datePickerVal: "",
      beginTime: "",
      fromAddress: "",
      toAddress: "",
      endTime: "",
      demandNo: "",
      page: 1,
      //当前页数
      size: 9,
      //一页几条
      total: 0,
      //共几条
      pages: 0,
      //一共几页
      list: [],
      comps: [{
        label: "发货中",
        name: "Delivery"
      }, {
        label: "发货历史",
        name: "DeliveryHistory"
      }]
    });
    const dialog = reactive({
      visible: false,
      bufferRecord: {}
    });
    onMounted(() => {
      selectDemandList();
    });
    //查询货源列表
    const selectDemandList = async () => {
      const params = {
        beginTime: data.beginTime,
        demandNo: data.demandNo,
        endTime: data.endTime,
        fromAddress: data.fromAddress,
        page: data.page,
        size: data.size,
        toAddress: data.toAddress
      };
      var res = await globalProperties.$api.selectDemandList(params);
      data.list = res.records;
      data.page = res.current;
      data.size = res.size;
      data.total = res.total;
    };

    //查询历史货源列表
    const selectDemandHistoryList = async () => {
      const params = {
        beginTime: data.beginTime,
        demandNo: data.demandNo,
        endTime: data.endTime,
        fromAddress: data.fromAddress,
        page: data.page,
        size: data.size,
        toAddress: data.toAddress
      };
      var res = await globalProperties.$api.selectDemandHistoryList(params);
      data.list = res.records;
      data.page = res.current;
      data.size = res.size;
      data.total = res.total;
    };

    //下载模板
    const downloadDemandTemplate = async () => exportFile(await globalProperties.$api.downloadDemandTemplate(), `货源模板`);

    //导入货源
    const importVehicleType = async value => {
      const formData = new FormData();
      formData.append("file", value.raw);
      var res = await globalProperties.$api.importDemand(formData);
      if (res) {
        serarch(data.tabsIndex);
        ElMessage.success("导入成功!");
      }
    };

    //重置
    const reset = () => {
      data.datePickerVal = "";
      data.beginTime = "";
      data.demandNo = "";
      data.endTime = "";
      data.fromAddress = "";
      data.page = 1;
      data.size = 9;
      data.toAddress = "";
      serarch(data.tabsIndex);
    };

    //搜索
    const serarch = async index => {
      await (data.tabsIndex = index);
      data.tabsIndex ? selectDemandHistoryList() : selectDemandList();
    };
    const pickDateHandle = e => {
      data.beginTime = e[0];
      data.endTime = e[1];
    };

    //下架
    const handleDeleteDemand = async demandId => {
      var res = await globalProperties.$api.selectDemandIsHaveTransport(demandId);
      if (res) {
        ElMessageBox.confirm("当前货源还有关联运单正在运输中，确认继续下架？", "", {
          confirmButtonText: "确定",
          cancelButtonText: "再想想",
          type: "warning"
        }).then(() => {
          removeDemand(demandId);
        }).catch(() => {});
        return;
      }
      removeDemand(demandId);
    };

    //下架货源
    const removeDemand = async demandId => {
      await globalProperties.$api.removeDemand(demandId);
      await serarch(data.tabsIndex);
      ElMessage.success("下架成功");
    };

    //查看详情
    const toViewDemandDetail = demandId => {
      router.push({
        path: "/layout/shipmentsdetail",
        query: {
          demandId,
          onlyViewBasicInfo: data.tabsIndex
        }
      });
    };
    const addDemandPrice = (demandId, amount) => {
      ElMessageBox.prompt(`当前货源单价${amount / 100}元/吨
      `, "我要改价", {
        confirmButtonText: "确定",
        inputPlaceholder: "请输入改价后单价",
        cancelButtonText: "取消",
        inputPattern: /^\d+(\.\d{1,2})?$/,
        inputErrorMessage: "价格格式有误"
      }).then(async ({
        value
      }) => {
        const params = {
          amount: Number(value) * 100,
          demandId
        };
        await globalProperties.$api.addDemandPrice(params);
        serarch(data.tabsIndex);
      }).catch(() => {});
    };
    const edit = (demandId, again = 0) => {
      router.push({
        path: `/layout/ordinary`,
        query: {
          demandId,
          again
        }
      });
    };
    const currentChange = value => {
      data.page = value;
      data.tabsIndex ? selectDemandHistoryList() : selectDemandList();
    };
    const sharePic = async record => {
      try {
        const res = await globalProperties.$api.selectDemandIsCanShare(record.demandId);
        if (!res) {
          ElMessage.warning("该货源待后台审核通过后可分享");
          return;
        }
        const {
          distance,
          addressList,
          packageName
        } = await globalProperties.$api.selectDemandDetail(record.demandId);
        const loading = addressList.find(item => item.addressType === 1);
        const unloading = addressList.find(item => item.addressType === 2);
        dialog.bufferRecord = {
          ...record,
          distance,
          loading,
          unloading,
          packageName
        };
        dialog.visible = true;
        await new Promise(resolve => setTimeout(resolve, 200));
        const canvas = qrCanvas.value;
        if (!canvas) {
          console.error("canvas 不存在");
          return;
        }

        // 5. 清空画布
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const shipper = isPhoneNumber(mainStore.userInfo?.nickName) ? phoneDesc(mainStore.userInfo?.nickName) : EncryptName(mainStore.userInfo?.nickName);
        const url = `https://sanqianjiuyun.com/mobile/open_app_match.html?id=${record.demandId}&shipper=${shipper}&from=${loading.city}&to=${unloading.city}`;
        await QRCode.toCanvas(canvas, url, {
          width: 150,
          margin: 1,
          errorCorrectionLevel: "H"
        });
        const img = new Image();
        img.src = logo;
        img.crossOrigin = "anonymous";
        img.onload = () => {
          const size = 40;
          const x = (150 - size) / 2;
          const y = (150 - size) / 2;

          // 白色圆底
          ctx.beginPath();
          ctx.arc(x + size / 2, y + size / 2, size / 2 + 6, 0, Math.PI * 2);
          ctx.fillStyle = "#fff";
          ctx.fill();
          ctx.drawImage(img, x, y, size, size);
        };
        img.onerror = () => {
          console.error("logo 加载失败，请检查路径：", logo);
        };
      } catch (e) {
        ElMessage.error("生成二维码失败：" + e.message);
      }
    };

    // 转图片并下载
    const downloadPic = async () => {
      try {
        const dom = document.getElementById("shareImage");
        if (!dom) {
          ElMessage.error("找不到分享区域");
          return;
        }

        // 关键：给弹窗内容强制加样式，保证能截图
        dom.style.display = "block";
        dom.style.opacity = "1";
        dom.style.visibility = "visible";
        html2canvas(dom, {
          useCORS: true,
          scale: 2,
          logging: false,
          allowTaint: false,
          backgroundColor: "#ffffff"
        }).then(canvas => {
          // 转图片并下载
          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = "九运易合货源分享_" + Date.now() + ".png";
          link.click();
        }).catch(err => {
          ElMessage.error("下载失败：" + err.message);
        });
      } catch (e) {
        ElMessage.error("下载异常");
      }
    };

    //转图片并复制
    const copyPic = async () => {
      try {
        const dom = document.getElementById("shareImage");
        if (!dom) {
          ElMessage.error("找不到内容区域");
          return;
        }

        // 生成图片
        const canvas = await html2canvas(dom, {
          useCORS: true,
          scale: 2,
          backgroundColor: "#ffffff",
          logging: false
        });

        // 转 blob
        const blob = await new Promise(resolve => canvas.toBlob(resolve, "image/png"));

        // 复制到剪贴板 ✅
        await navigator.clipboard.write([new ClipboardItem({
          "image/png": blob
        })]);
        ElMessage.success("图片已复制到剪贴板！");
      } catch (err) {
        console.error("复制失败：", err);
        ElMessage.error("复制失败，请重试");
      }
    };
    return {
      copyPic,
      mainStore,
      sharePic,
      qrCanvas,
      downloadPic,
      toViewDemandDetail,
      pickDateHandle,
      handleDeleteDemand,
      serarch,
      reset,
      freightUnitTypeMap,
      data,
      isPassAuth,
      downloadDemandTemplate,
      importVehicleType,
      addDemandPrice,
      edit,
      moment,
      currentChange,
      dialog,
      zhCn
    };
  }
};